import { FC } from "react";

export const SentEmailIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4579 18.4131L10.0489 14.9992L11.0444 14.0037L13.4579 16.4122L18.4964 11.3787L19.4918 12.3742L13.4579 18.4131ZM10.2287 8.96611L17.1422 4.62823H3.31521L10.2287 8.96611ZM10.2287 10.3307L3.23187 5.90948V15.1219H8.39583L9.81521 16.5413H3.23187C2.84856 16.5413 2.51616 16.4005 2.23469 16.1191C1.95323 15.8376 1.8125 15.5052 1.8125 15.1219V4.62823C1.8125 4.24355 1.95323 3.90999 2.23469 3.62754C2.51616 3.34509 2.84856 3.20386 3.23187 3.20386H17.2464C17.6311 3.20386 17.9646 3.34509 18.2471 3.62754C18.5295 3.90999 18.6708 4.24355 18.6708 4.62823V9.41265L17.2464 10.832V5.90948L10.2287 10.3307Z"
        fill="currentColor"
      />
    </svg>
  );
};
